import Papa from "papaparse";

interface FieldExample {
  fieldName: string;
  exampleValue: string;
  fieldIndex: number;
}

export default function getCSVColumns(file: File): Promise<FieldExample[]> {
  return new Promise((resolve) => {
    Papa.parse<Record<string, string>>(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results: Papa.ParseResult<Record<string, string>>) {
        const fields = Object.keys(results.data[0]);
        const fieldExamples: FieldExample[] = fields.map((field, index) => {
          let exampleValue = "";
          for (let i = 0; i < results.data.length && !exampleValue; i++) {
            const value = results.data[i][field];
            if (
              value &&
              value !== "0" &&
              value.toLowerCase() !== "null" &&
              value.toLowerCase() !== "undefined"
            ) {
              exampleValue = value;
              break;
            }
          }
          return { fieldName: field, exampleValue, fieldIndex: index };
        });

        resolve(fieldExamples);
      },
    });
  });
}
